import React from "react";
import img from "../../Assets/img-1.jpg";
import img1 from "../../Assets/img-2.jpg";
import img2 from "../../Assets/img-3.jpg";
import img3 from "../../Assets/img-4.jpg";

const Value = () => {
  return (
    <div className=" mt-0  bg-[#fdfbf0] p-4   mx-auto">
      {/* Section Title */}
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 text-center">
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          Values We Preserve
        </h1>
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
      </div>

      {/* Description */}
      <div className="max-w-4xl mt-5 text-center mx-auto px-4">
        <p className="text-base sm:text-xl text-gray-700 font-sans">
          We create spaces that enable Everyday Joys — one community, one family,
          and one home at a time. Quality Thriving Communities.
        </p>
      </div>  
<div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 mt-8 px-2">
  {[img, img1, img2, img3].map((image, index) => (
    <img
      key={index}
      src={image}
      alt={`value-${index}`}
      loading="lazy"
      className="w-full sm:w-72 md:w-80 h-72 sm:h-[400px] object-cover rounded"
    />
  ))}
</div>

      {/* Button */}

      <div className="flex justify-center mt-8">
        <button className="border border-black px-5 py-2 text-sm sm:text-base hover:bg-black hover:text-white transition">
          OUR BRAND STORY
        </button>
      </div>
    </div>
  );
};

export default Value;
